var ko = require('knockout'),
  AUTHORIZATION_TYPE = require('_js/constants/authorization'),
  filter = require('lodash/filter');

function CourseBlock(params) {
  this.parent = params.parent;
  this.params = params;
  this.data = params.data;
  this.API = params.api;
  this.excludeImage = params.excludeImage;
  this.planned = params.planned || false;
  var startAuth = window.authorizedAccountant
    ? AUTHORIZATION_TYPE.ACCOUNTANT
    : AUTHORIZATION_TYPE.AUDITOR;
  // Listen to the authorization type (accountant or "revisor").
  this.AuthorizationType = ko
    .observable(startAuth)
    .subscribeTo('authorizationType', true);
  // Filter the credits based on which authorization type to use.
  this.filteredCredits = ko.computed(function() {
    return filter(this.data.Course.ActiveAuthorizationCredits, {
      AuthorizationType: this.AuthorizationType()
    });
  }, this);

  this.purchased = ko.observable(false);
  this.isExpanded = ko.observable(false);
  if (this.data.Course.FromDate !== null) {
    var date = new Date(this.data.Course.FromDate);
    this.dateFormatted =
      '' + date.getDate() + '.' + date.getMonth() + '.' + date.getFullYear();
  }

  this.shortDescription = ko.computed(function() {
    if (this.data.Course.ShortDescription) {
      var div = document.createElement('div');
      div.innerHTML = this.data.Course.ShortDescription;
      return div.textContent || div.innerText || '';
    }
    return '';
  }, this);

  ko.postbox.subscribe(
    'removeCourseWithKey',
    function(key) {
      if (key === this.data.CartObject.Key) {
        this.purchased(false);
      }
    },
    this,
    true
  );
}

CourseBlock.prototype.init = function(element) {
  this.$element = $(element);
  this.$expandable = $(this.$element.next('.expandable-course').get(0));
};

CourseBlock.prototype.buyCourse = function() {
  ko.postbox.publish('buyCourse', this.data.CartObject);
  this.purchased(true);
};

CourseBlock.prototype.expand = function() {
  var self = this;
  if (this.isExpanded()) {
    this.$expandable.slideUp(250, 'easeOutQuad', function() {
      self.isExpanded(!self.isExpanded());
    });
  } else {
    self.isExpanded(!self.isExpanded());
    this.$expandable.slideDown(250, 'easeOutQuad', function() {});
  }
};

module.exports = CourseBlock;
